// Remove focus outline from mega menu items
document.addEventListener('DOMContentLoaded', function() {
  // Target the mega menu items and remove focus outline
  const style = document.createElement('style');
  style.textContent = `
    .mega-menu .header__menu-item:focus,
    .mega-menu .header__menu-item:focus-visible,
    .mega-menu .header__menu-item:focus-within,
    .mega-menu > summary:focus,
    .mega-menu > summary:focus-visible,
    .mega-menu > summary:focus-within {
      outline: none !important;
      box-shadow: none !important;
      border: none !important;
      text-decoration: none !important;
    }
  `;
  document.head.appendChild(style);

  // Also add an event listener to remove focus outline when clicking
  document.querySelectorAll('.mega-menu .header__menu-item, .mega-menu > summary').forEach(item => {
    item.addEventListener('mousedown', function(e) {
      e.preventDefault();
      this.style.outline = 'none';
      this.style.boxShadow = 'none';
      this.style.border = 'none';
      
      // Programmatically click the element after a small delay to maintain functionality
      const href = this.getAttribute('href');
      if (href && href !== '#') {
        setTimeout(() => {
          window.location.href = href;
        }, 0);
      }
    });
  });
});
